export default __webpack_public_path__ + "static/media/twitter.1a1cae9f.svg";